// Page layout shared by the apps: header, main area (sidebar + page), footer, cookie bar.
// The slots are app components (HeaderShell, SideBarShell... wrapped with the app data).
const AppShell = ({ header, sidebar, footer, cookieBar, isIcon, children }) => (
  <>
    {header}
    <main className={`container ${isIcon ? "icon" : ""}`}>
      {sidebar}
      {children}
    </main>
    {footer}
    {cookieBar}
  </>
);

export default AppShell;
